enum ToastStatusEnum {
  Error = "error",
  Warning = "warning",
  Success = "success",
  Info = "info"
}

export default ToastStatusEnum;
